// Initialize mobile menu
(function() {
    // Mobile Menu Trigger
    var burger = document.querySelector('.gh-burger');
    if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.addEventListener('click', function() {
            var isOpen = document.body.classList.toggle('gh-head-open');
            burger.setAttribute('aria-expanded', String(isOpen));
        });
    }
})();

// Mobile scroll-to-top button
(function() {
    var toTop = document.querySelector('.gh-scroll-top');
    if (!toTop) {
        return;
    }
    var showAt = 600;
    var toggle = function() {
        toTop.classList.toggle('is-visible', window.scrollY > showAt);
    };
    window.addEventListener('scroll', toggle, {passive: true});
    toggle();
    toTop.addEventListener('click', function() {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });
})();
